var render = function () {
  var _vm$billingDetails, _vm$billingDetails2, _vm$billingDetails3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "invoiceConfirmModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "lg",
      "hide-header-close": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('h6', {
          staticClass: "modal-refund-title"
        }, [_vm._v("Confirm Refund? ")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "view-clients-modal-content"
  }, [_c('div', {
    staticClass: "addMessage-form"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("ID:")])]), _c('td', [_vm._v(_vm._s(_vm.row.paymentID))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Member Name:")])]), _c('td', [_vm._v(_vm._s(_vm.row.payment_ben_name))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Amount:")])]), _c('td', [_vm._v("$" + _vm._s(_vm.row.payamount))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Refund Type:")])]), _c('td', [_vm._v("CC")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Card Number:")])]), _c('td', [_vm._v(_vm._s((_vm$billingDetails = _vm.billingDetails) !== null && _vm$billingDetails !== void 0 && _vm$billingDetails.card_num ? 'xxxx-' + _vm.billingDetails.card_num : 'N/A'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Card Type:")])]), _c('td', [_vm._v(_vm._s((_vm$billingDetails2 = _vm.billingDetails) !== null && _vm$billingDetails2 !== void 0 && _vm$billingDetails2.brand ? (_vm$billingDetails3 = _vm.billingDetails) === null || _vm$billingDetails3 === void 0 ? void 0 : _vm$billingDetails3.brand : 'N/A'))])])])]), _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-xxl-5 mb-4"
  }, [_c('b-button', {
    staticClass: "univ-btn",
    on: {
      "click": function click($event) {
        return _vm.$emit('confirmRefundPayment');
      }
    }
  }, [_vm._v(" Send ")])], 1)])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }